import React from 'react';
import { OrdersExpander } from './OrdersExpander';
import { HistoryOrder } from './order/HistoryOrder';

export class HistoryOrdersGroup extends React.Component {
    renderOrder(order, drivers) {
        return <HistoryOrder order={order} drivers={drivers} />;
    }

    render() {
        const { isOpen, orders, toggle, title, drivers } = this.props;
        return (
            <OrdersExpander isOpen={isOpen} orders={orders} toggle={toggle} title={title} orderHeight={162}>
                {orders.map(order => this.renderOrder(order, drivers))}
            </OrdersExpander>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/sidebarOrders/HistoryOrdersGroup.js